// En este container se introducen los datos referentes a los movimientos económicos del cierre diario.
// Contiene un componente CentroDia que permite seleccionar el centro y la fecha de cierre ( el centro solamente si el usuario tiene permisos ). 
// El centro y el día están guardados en el store de la aplicación.
// Se obtienen los datos mediante la acción getDatosCierreDiario una vez hay un centro y un dia seleccionados. 
// La primera vez que se entra se llama a la acción setCentroDia para obtener el ultimo dia abierto para el centro seleccionado.
// Una vez se obtienen los datos del cierre diario, se genera una estructura de:
//      - Cajas.
//          - Zonas.
//              - Conceptos de ingresos/pagos.
// Todos los controles de conceptos del cierre diario se renderizan mediante el componente CierreDiarioItem (cierre_diario_item.js).
// CierreDiarioItem hace uso de los componentes CierreDiarioArcadeGrid, CierreDiarioGastosGrid, CierreDiarioMKTGrid, CierreDiarioPartidaTiposGrid y CierreDiarioPorHoras 
//      para mostrar la edición de cada uno de los conceptos de ingreso o pago dependiendo de su tipo.
//El botón de guardar llama a la acción updateCierreDiarioDatosDB para actualizar la información de estos movimientos económicos en el servidor y hace un nextStep del Stepper de AccCierreDiario 
//    para que se muestre el componente CierreDiarioOtrosDatos.

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

//actions:
import { getDatosCierreDiario, modifyDatosCierreDiario, updateCierreDiarioDatosDB } from '../../actions/cierre_diario_actions';
import { setCentroDia } from '../../actions/centro_dia_actions';
import { openDialog, setSaveState } from '../../actions';

//material ui:
import CircularProgress from '@material-ui/core/CircularProgress';
import { Paper, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

//components:
import CentroDia from '../centro_dia';
import CierreDiarioItem from './cierre_diario_item';
import FloatNumberFormatText from '../../components/float_number_text_formatter';
import {fusionarItemsCaja, orderZonas} from '../../constants/utils';

const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        margin: theme.spacing(1),
        flexGrow: 1,
    },
    paperCaja: {
        backgroundColor: '#E8F1D7',
        boxShadow: 'none',
        borderBottom: '3px solid #b8b8b8',
        borderRight: '3px solid #b8b8b8',
        borderRadius: '0px',
        margin: '25px 0',
        padding: 10,
    },
    paperConcepto: {
        padding: 0,
        margin: theme.spacing(1),
        borderBottom: '3px solid #b8b8b8',
        borderRight: '3px solid #b8b8b8',
        borderRadius: '0px',
    },
    paperZona: {
        padding: 0,
        margin: 0,
        borderRadius: 0,
    },
    titleIngresos: {
        fontSize: 13,
        fontWeight: '500',
        color: 'white',
        backgroundColor: theme.palette.primary.main,
        padding: '4px 2px 4px 12px',
    },
    titlePagos: {
        fontSize: 13,
        fontWeight: '500',
        color: 'white',
        backgroundColor: theme.palette.secondary.main,
        padding: '4px 2px 4px 12px',
    },
    titleZona: {
        fontSize: 13,
        fontWeight: '500',
        backgroundColor: '#e6e6e6',
        padding: '4px 2px 4px 12px',
        borderBottom: '3px solid #b8b8b8'
    },
    containerItems: {
        width: '100%',
        margin: '8px auto',
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        marginBottom: 60,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    cover: {
        position: 'absolute',
        height: '100%',
        width: '100%',
        zIndex: 1,
        backgroundColor: '#ddd',
        opacity: 0.3,
    },
    divData: {
        position: 'relative'
    },
    titleConceptoIngresos:
    {
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: theme.palette.primary.main,
        paddingRight: theme.spacing(1)
    },
    titleConceptoPagos:
    {
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: theme.palette.secondary.main,
        paddingRight: theme.spacing(1)
    }

});

class CierreDiarioDatos extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showSpinner: false,
        };

    };
    componentDidMount() {
        if (this.props.first) {
            if (this.props.centroDiaSelected.centro.id !== undefined && this.props.centroDiaSelected.dia !== '' && !this.props.centroDiaSelected.centro.isGroup) {
                this.props.setCentroDia(this.props.centroDiaSelected.centro.id, undefined, false);
                //this.props.getDatosCierreDiario(this.props.centroDiaSelected.centro.id, this.props.centroDiaSelected.dia);
            };
        }
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.centroDiaSelected.centro !== this.props.centroDiaSelected.centro ||
            prevProps.centroDiaSelected.dia !== this.props.centroDiaSelected.dia) {
            this.setState({ showSpinner: true })
            this.props.getDatosCierreDiario(this.props.centroDiaSelected.centro.id, this.props.centroDiaSelected.dia);
        }
        if (prevProps.isLoading !== this.props.isLoading) this.setState({ showSpinner: this.props.isLoading });
        if (prevProps.isLoading !== this.props.isLoading) this.setState({ showSpinner: this.props.isLoading });
    };

    generateCierreDiarioControls = () => {

        //create object from this.props.datosCierreDiario

        var datosCierre = [];
        //create a control for each of the items from datosCierreDiario
        // console.log(fusionarItemsCaja(this.props.datosCierreDiario), "fusionarItemsCaja")
        orderZonas(this.props.datosCierreDiario).forEach(item => {

            // if (typeof datosCierre[item.cajaId] === 'undefined') { //no existe la caja
            //     datosCierre[item.cajaId] = { cajaId: item.cajaId, descr: item.caja, iTipoZona: item.iTipoZona, conceptos: [] };
            // }
            let caja = datosCierre.find(c => c.cajaId === item.cajaId);
            if (caja === undefined) {
                caja = { cajaId: item.cajaId, descr: item.caja, iTipoZona: item.iTipoZona, conceptos: [] };
                datosCierre.push(caja);
            }

            // const caja = datosCierre[item.cajaId];

            // if (typeof caja.conceptos[item.isMovCaja] === 'undefined') { //no existe el concepto
            //     caja.conceptos[item.isMovCaja] = { concepto: item.concepto, isMovCaja: item.isMovCaja, zonas: [], cajaDescr: caja.descr };
            // }
            let concepto = caja.conceptos.find(c => c.isMovCaja === item.isMovCaja);
            if (concepto === undefined) {
                concepto = { concepto: item.concepto, isMovCaja: item.isMovCaja, zonas: [], cajaDescr: caja.descr };
                caja.conceptos.push(concepto);
            }

            // const concepto = caja.conceptos[item.isMovCaja];

            // if (typeof concepto.zonas[item.zonaId] === 'undefined') { //no existe la zona
            //     concepto.zonas[item.zonaId] = { zonaId: item.zonaId, descr: item.zona, iTipoZona: item.iTipoZona, productos: [] }
            // }

            let zona = concepto.zonas.find(z => z.zonaId === item.zonaId);
            if (zona === undefined) {
                zona = { zonaId: item.zonaId, descr: item.zona, iTipoZona: item.iTipoZona, productos: [] };
                concepto.zonas.push(zona);
            }
            //const zona = concepto.zonas[item.zonaId];
            //zona.productos[item.articuloId] = item;
            zona.productos.push(item);


        });

        const { classes } = this.props;

        //ponemos zona general al final
        var cajaGeneral = undefined;
        const newDatosCierre = [];
        datosCierre.forEach(c => {
            if (c.iTipoZona !== 9) newDatosCierre.push(c);
            else cajaGeneral = c;
        });
        if (cajaGeneral) newDatosCierre.push(cajaGeneral);


        return newDatosCierre.map((caja) => {
            if (caja.conceptos[0] !== undefined && caja.conceptos[1] !== undefined) {
                return (
                    <Paper key={'caja_' + caja.cajaId} className={classes.paperCaja}>

                        {this.generateConceptos(caja.cajaId, caja.conceptos)}

                    </Paper>
                )
            }
            else {
                return (<div key={'empty_' + caja.cajaId}></div>)
            }

        })

    }


    generateConceptos = (cajaid, conceptos) => {

        if (conceptos[0] !== undefined && conceptos[1] !== undefined) {

            const conceptoIngresos = conceptos.find(c => c.isMovCaja === 0);

            const conceptoPagos = conceptos.find(c => c.isMovCaja === 1);

            return (
                <Grid container spacing={8}>

                    <Grid item sm={6}>
                        {this.generateConceptosIngresos(conceptoIngresos)}
                    </Grid>

                    <Grid item sm={6}>
                        {this.generateConceptosPagos(conceptoPagos)}
                    </Grid>

                </Grid>
            )
        }
    }

    generateConceptosIngresos = (conceptoIngresos, cajaid) => {

        if (conceptoIngresos === undefined) {
            return (<div></div>);
        }

        let total = 0.0;

        conceptoIngresos.zonas.forEach(z => {
            z.productos.forEach(p => {
                total += parseFloat(p.importe);
            });
        });

        const { classes } = this.props;

        return (

            <Paper key={'concepto_' + cajaid + '_0'} className={classes.paperConcepto} elevation={0}>
                <div className={classes.titleConceptoIngresos}>
                    <Typography className={classes.titleIngresos} variant="subtitle1">
                        {conceptoIngresos.concepto + ' - ' + conceptoIngresos.cajaDescr}
                    </Typography>
                    <Typography className={classes.titleIngresos} variant="subtitle1">Total: <FloatNumberFormatText value={total} /></Typography>
                </div>
                {this.generateZonas('ingresos', conceptoIngresos.zonas)}
            </Paper>

        )
    }

    generateConceptosPagos = (conceptoPagos, cajaid) => {
        if (conceptoPagos === undefined) {
            return (<div></div>);
        }

        let total = 0.0;

        conceptoPagos.zonas.forEach(z => {
            z.productos.forEach(p => {
                total += parseFloat(p.importe);
            });
        });

        const { classes } = this.props;
        return (

            <Paper key={'concepto_' + cajaid + '_1'} className={classes.paperConcepto} elevation={0}>
                <div className={classes.titleConceptoPagos}>
                    <Typography className={classes.titlePagos} variant="subtitle1">
                        {conceptoPagos.concepto + ' - ' + conceptoPagos.cajaDescr}
                    </Typography>
                    <Typography className={classes.titlePagos} variant="subtitle1">Total: <FloatNumberFormatText value={total} /></Typography>
                </div>
                {this.generateZonas('pagos', conceptoPagos.zonas)}
            </Paper>

        )
    }


    generateZonas = (concepto, zonas) => {
        const { classes } = this.props;

        return zonas.map((zona) => {

            return (
                <Paper key={'zona_' + concepto + '_' + zona.zonaId} className={classes.paperZona} elevation={0}>
                    <Typography className={classes.titleZona} variant="subtitle1">
                        {zona.descr}
                    </Typography>
                    <div className={classes.containerItems}>
                        {this.generateProductos(zona.productos)}
                    </div>
                </Paper>
            )

        })
    }

    modifyValue = (v, producto) => {
        this.props.setSaveState(true);
        this.props.modifyDatosCierreDiario({ ...producto, importe: v });
    }

    compare = (a, b) => {
        if (a.producto < b.producto)
            return 1;
        if (a.producto > b.producto)
            return -1;
        return 0;
    }


    generateProductos = (productos) => {

        // let sortedProductos = productos.map(p => p);
        // sortedProductos.sort(this.compare);

        // let productosOK = [];
        // sortedProductos.forEach(p => productosOK.push(p));

        let productosOK = [];
        productos.forEach(p => productosOK.push(p));

        return productosOK.map((producto) => {

            const key = producto.articuloId;

            if (producto.iKind === -7) {

                const ventasPack = productosOK.find(p => p.iKind === -8);
                return (
                    <CierreDiarioItem key={key} producto={producto} productoRelacionado={ventasPack} />
                )

            }
            else {

                if (producto.legKind === -2 && producto.isMovCaja === 0) {

                    const cREDSYS = this.props.datosCierreDiario.find(p => p.legKind === -2 && p.isMovCaja === 1); 
                    return (
                        <CierreDiarioItem key={key} producto={producto} productoRelacionado={cREDSYS} />
                    )

                }
                else {
                    return (
                        <CierreDiarioItem key={key} producto={producto} />
                    )
                }
            }

        });

    }

    hanldeOKClick = () => {
        if (!this.props.isDiaCerrado) {
            //update cierre diario datos data
            var producto = this.props.datosCierreDiario.find(p => p.iKind === -5);
            if (producto) {
                if (parseInt(producto.button1) !== parseInt(producto.button2)) {
                    this.props.openDialog('SimpleMessage', {
                        message: 'El número de partidas por horas y el número de partidas por tipo no coinciden'
                    }, 'cierre-diario-datos-error-numero-de-partidas', false, 'sm');
                    return;
                }
            }

            this.props.updateCierreDiarioDatosDB(this.props.datosCierreDiario, this.props.centroDiaSelected.centro.id, this.props.centroDiaSelected.dia, this.saveHandler);

            // var producto = this.props.datosCierreDiario.find(p => p.iKind === -5);
            // if (producto) {
            //     if (parseInt(producto.button1) === parseInt(producto.button2)) {
            //         this.props.nextStep();
            //     }
            //     else {
            //         this.props.openDialog('SimpleMessage', {
            //             message: 'El número de partidas por horas y el número de partidas por tipo no coinciden'
            //         }, 'cierre-diario-datos-error-numero-de-partidas', false, 'sm');
            //     }
            // }
            // else {

            //     this.props.nextStep();
            // }
        }
        else {
            this.props.nextStep();
        }
    }

    saveHandler = () => {
        this.props.setSaveState(false);
        this.props.nextStep();
    }

    render() {

        const { classes } = this.props;

        if (!this.props.datosCierreDiario.length && !this.state.showSpinner) {

            return (
                <div className={classes.root}>
                    <CentroDia semanal={false} />
                </div>
            );
        }

        else if (this.state.showSpinner) {
            return (
                <div className={classes.root}>
                    <CentroDia semanal={false} />

                    <div className={classes.spinnerContainer}>
                        <CircularProgress className={classes.spinner} color="primary" />
                    </div>
                </div>
            );
        };

        return (
            <div className={classes.root}>
                <CentroDia semanal={false} />

                <div className={classes.divData}>
                    <div className={classes.cover} style={{ display: this.props.centroDiaSelected.isValid ? 'none' : 'block' }} ></div>
                    {this.generateCierreDiarioControls()}
                </div>

                <div>
                    <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={this.hanldeOKClick} disabled={!this.props.centroDiaSelected.isValid}>
                        {this.props.isDiaCerrado ? 'Siguiente' : 'Guardar'}
                    </Button>
                </div>
            </div>
        );

    };
};

CierreDiarioDatos.propTypes = {
    user: PropTypes.object,
    centroDiaSelected: PropTypes.object.isRequired,
    datosCierreDiario: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isDiaCerrado: PropTypes.bool.isRequired,
    getDatosCierreDiario: PropTypes.func.isRequired,
    modifyDatosCierreDiario: PropTypes.func.isRequired,
    updateCierreDiarioDatosDB: PropTypes.func.isRequired,
    nextStep: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        centroDiaSelected: state.centroDiaSelected,
        datosCierreDiario: state.datosCierreDiario.datos,
        isLoading: state.datosCierreDiario.isLoading,
        isDiaCerrado: state.centroDiaSelected.isDiaCerrado,
        saveState: state.saveState,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        getDatosCierreDiario,
        modifyDatosCierreDiario,
        updateCierreDiarioDatosDB,
        openDialog,
        setCentroDia,
        setSaveState
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(CierreDiarioDatos));
